var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoutouts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.73503 7.4493C8.72143 7.4493 9.83879 6.33194 9.83879 4.34552C9.83879 2.35911 8.72143 1.24176 6.73503 1.24176C4.74862 1.24176 3.63126 2.35911 3.63126 4.34552C3.63126 6.33194 4.74862 7.4493 6.73503 7.4493Z",
    stroke: "#000000",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4523 11.7553C11.855 9.79546 10.1686 11.188 10.1464 12.6891C10.1464 14.9239 12.8203 16.7582 13.4523 16.7582C14.0844 16.7582 16.7582 14.9239 16.7582 12.6891C16.736 11.188 15.0496 9.79546 13.4523 11.7553Z",
    stroke: "#000000",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69275 14.174H3.30796C1.48388 14.174 0.458726 12.2238 1.9769 11.2126C3.33868 10.3056 4.97409 9.77704 6.73296 9.77704C7.33665 9.77704 7.92579 9.83931 8.49433 9.95777",
    stroke: "#000000",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoutouts);
export default __webpack_public_path__ + "static/media/shoutouts.99d7dcb2728b73d2c608afbddcfd8bf2.svg";
export { ForwardRef as ReactComponent };